import {MouseEvent, useEffect} from 'react'
import Image from 'next/image'
import Avatar from '@/components/Avatar'
import styles from '@/components/Header/Header.module.scss'
import Loading from '@/components/Loading'
import dayjs from 'dayjs'

const NoNotification = () => {
  return (
    <div className={styles.noNotification}>
      <Image src={process.env.NEXT_PUBLIC_PATH_DOMAIN + 'images/header/mascot-notification.svg'} width={150} height={150} alt="" />
      <p>
        Hiện không có thông báo nào.
        <br />
        <a href="https://noti.onlive.vn/setting">Thiết lập thông báo</a> để tùy
        chọn thông báo bạn muốn nhận
      </p>
    </div>
  )
}

type HeaderNotificationsListProps = {
  loading: boolean
  notifications: any[]
  refetch: ({isRefresh}: {isRefresh?: boolean | undefined}) => void
  handleReadNotification: (seq: string) => void
  inSidebar?: boolean
  handleDeleteNotification: (seq: string) => void
}

const HeaderNotificationsList = ({
  loading,
  notifications,
  refetch,
  handleReadNotification,
  inSidebar,
  handleDeleteNotification,
}: HeaderNotificationsListProps) => {
  const scrollListener = (e: any): void => {
    if (e?.currentTarget) {
      if (
        e?.currentTarget.scrollTop + e?.currentTarget.clientHeight ===
        e?.currentTarget.scrollHeight
      ) {
        refetch({})
      }
    }
  }

  useEffect(() => {
    const notificationsList = document.getElementById('notificationsList')

    if (notificationsList) {
      notificationsList.addEventListener('scroll', scrollListener, {
        passive: true,
      })
    }

    return () => {
      if (notificationsList) {
        notificationsList.removeEventListener('scroll', scrollListener)
      }
    }
  }, [])

  return (
    <div
      className={`notificationsListWrapper ${loading ? 'loading-data' : ''}`}
    >
      {loading && <Loading />}
      <div className={styles.notificationsList} id="notificationsList">
        {notifications?.length > 0 &&
          notifications.map((noti) => {
            const notiTime = dayjs(noti?.REG_DATE).format('HH:mm:ss')
            const notiDate = dayjs(noti?.REG_DATE).format('DD/MM/YYYY')

            return (
              <a
                key={noti?.SEQ}
                href={noti?.URL}
                target="_blank"
                className={`${styles.notificationItem}${
                  noti?.READ_FLAG === '1' ? ' read' : ''
                }`}
                onClick={() => handleReadNotification(noti?.SEQ.toString())}
              >
                <div className={styles.notificationAvatar}>
                  <Avatar bjId={noti?.FROM_ID} width={80} height={80} />
                </div>
                <div className={styles.notificationInfo}>
                  <div
                    className={styles.notificationTitle}
                    dangerouslySetInnerHTML={{__html: noti?.NOTI_TITLE}}
                  />
                  <div className={styles.notificationTime}>
                    {notiTime} - {notiDate}
                    {noti?.STATION_NAME ? (
                      <>
                        <span className={styles.dot} />
                        {noti?.STATION_NAME}
                      </>
                    ) : null}
                  </div>
                </div>
                <button
                  className={
                    styles.notificationDelete + (inSidebar ? ' inSidebar' : '')
                  }
                  onClick={(e: MouseEvent<HTMLButtonElement>) => {
                    e.stopPropagation()
                    e.preventDefault()
                    handleDeleteNotification(noti?.SEQ.toString())
                  }}
                >
                  <Image
                    src={process.env.NEXT_PUBLIC_PATH_DOMAIN + 'images/icons/header/close.svg'}
                    width={18}
                    height={18}
                    alt=""
                  />
                </button>
              </a>
            )
          })}
        {!loading && notifications.length === 0 && <NoNotification />}
      </div>
    </div>
  )
}

export default HeaderNotificationsList
